"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_options_core_2 = require("owa-options-core");
var owa_options_core_3 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var ReadingPanePosition_1 = require("owa-session-store/lib/store/schema/ReadingPanePosition");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var owa_analytics_1 = require("owa-analytics");
var saveReadingPanePositionOptionStitchName = 'saveReadingPanePositionOptionStitchName';
var saveReadingPaneOption = legacy_1.action('saveReadingPaneOption')(function saveReadingPaneOption(newReadingPanePosition, userOptions, newNextSelection, newLoadFirstMessageOnLogon) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var servicePromises, serverUpdates, showReadingPane, serviceBehavior;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    servicePromises = [];
                    serverUpdates = [];
                    showReadingPane = newReadingPanePosition != ReadingPanePosition_1.default.Off;
                    // Deal with the new ReadingPane position
                    if (newReadingPanePosition !== userOptions.GlobalReadingPanePositionReact) {
                        userOptions.GlobalReadingPanePositionReact = newReadingPanePosition;
                        // Raise stitch so that, if we're running in mail, it'll trigger 3 line view or single line view
                        stitch_1.raiseAction(saveReadingPanePositionOptionStitchName)(newReadingPanePosition);
                        serverUpdates.push({
                            propertyName: 'GlobalReadingPanePositionReact',
                            propertyType: 'Integer32',
                            propertyValue: String(newReadingPanePosition),
                        });
                    }
                    // Deal with ShowReadingPaneOnFirstLoad
                    if (newLoadFirstMessageOnLogon !== undefined &&
                        newLoadFirstMessageOnLogon !== userOptions.ShowReadingPaneOnFirstLoad) {
                        userOptions.ShowReadingPaneOnFirstLoad = newLoadFirstMessageOnLogon;
                        serverUpdates.push({
                            propertyName: 'ShowReadingPaneOnFirstLoad',
                            propertyType: 'Boolean',
                            propertyValue: "" + userOptions.ShowReadingPaneOnFirstLoad,
                        });
                    }
                    // Send request to update RP position and ShowReadingPaneOnFirstLoad
                    if (serverUpdates.length) {
                        servicePromises.push(owa_options_core_3.updateUserConfiguration(serverUpdates));
                    }
                    // Deal with the new 'NextSelection'
                    if (showReadingPane && (newNextSelection || userOptions.NextSelection) == 'ReturnToView') {
                        newNextSelection = 'Next';
                    }
                    if (newNextSelection && newNextSelection !== userOptions.NextSelection) {
                        userOptions.NextSelection = newNextSelection;
                        serviceBehavior = void 0;
                        switch (userOptions.NextSelection) {
                            case 'Previous':
                                serviceBehavior = 0 /* OpenPreviousItem */;
                                break;
                            case 'Next':
                                serviceBehavior = 1 /* OpenNextItem */;
                                break;
                            case 'ReturnToView':
                                serviceBehavior = 2 /* ReturnToView */;
                                break;
                        }
                        servicePromises.push(owa_options_core_1.setMailboxMessageConfiguration({
                            AfterMoveOrDeleteBehavior: serviceBehavior,
                        }));
                    }
                    return [4 /*yield*/, Promise.all(servicePromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
exports.saveReadingPaneOptionFull = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveReadingPaneOptionFull')(function saveReadingPaneOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions, optionState = state.optionState;
                    return [4 /*yield*/, saveReadingPaneOption(owa_options_core_2.getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact), userOptions, optionState.nextSelection || userOptions.NextSelection, owa_options_core_2.getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingReadingPane';
exports.saveReadingPaneOptionQuick = legacy_1.select({
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveReadingPaneOptionQuick')(function saveReadingPaneOptionQuick(newReadingPanePosition, state) {
    var readingPanePositionString;
    switch (newReadingPanePosition) {
        case ReadingPanePosition_1.default.Off:
            readingPanePositionString = 'Off';
            break;
        case ReadingPanePosition_1.default.Right:
            readingPanePositionString = 'Right';
            break;
        case ReadingPanePosition_1.default.Bottom:
            readingPanePositionString = 'Bottom';
            break;
        default:
            readingPanePositionString = 'Unknown';
            break;
    }
    owa_analytics_1.logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [readingPanePositionString]);
    saveReadingPaneOption(newReadingPanePosition, state.userOptions);
}));
//# sourceMappingURL=saveReadingPaneOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/actions/saveReadingPaneOption.js
// module id = 3282
// module chunks = 2